import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@anyseal/ui/styles.css";
import { App } from "./App";
import { AuthProvider } from "./auth";
import { I18nProvider } from "./i18n";

const client = new QueryClient({ defaultOptions: { queries: { staleTime: 10_000, retry: 1, refetchOnWindowFocus: false } } });
const root = document.getElementById("root");
if (!root) throw new Error("Admin root element is missing");
createRoot(root).render(<StrictMode><BrowserRouter><QueryClientProvider client={client}><I18nProvider><AuthProvider><App /></AuthProvider></I18nProvider></QueryClientProvider></BrowserRouter></StrictMode>);
